import {useContext, useEffect, useState} from "react";
import {User} from "../../Context";
import {Link, useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import axios from "axios";
import {Oval} from "react-loader-spinner";
import GetOptions from "../../components/GetOptions";
import {Button} from "react-bootstrap";
import {Calendar} from "primereact/calendar";
import CompaniesOptions from "../companies/CompaniesOptions";
export default function AddSewagePlan() {
    const [company,setCompany] = useState(null)
    const [folderValus,setFolderValues] = useState({});
    const [loading,setLoading] = useState(false)
    const user = useContext(User)
    const token = user.auth.token
    const nav= useNavigate()
    const validate = values => {
        const errors = {};
        if (!values.plan_name) {
            errors.plan_name = 'حقل مطلوب';
        }
        if (!values.treatment_id) {
            errors.treatment_id = 'حقل مطلوب';
        }
        if (!values.user_id) {
            errors.user_id = 'حقل مطلوب';
        }
        if (!values.version) {
            errors.version = 'حقل مطلوب';
        }if (!values.plan_start) {
            errors.plan_start = 'حقل مطلوب';
        }
        if(!values.reviewer) {
            errors.reviewer = 'حقل مطلوب';
        }
        return errors;
    };


    useEffect(() => {
        let values = folderValus;
        values[`folder_1`]  = "خطابات الإعتماد"
        values[`evaluate_1`]  = 1
        values[`canAdd_1`]  = ['can_add_2','can_add_3','can_add_4']
        values[`about_1`]  = "خطاب إعتماد الخطة من الشركة التابعة-القابضة-الجهاز لتنظيمي-وزارة الصحة"


        values[`folder_2`]  = "خطابات وملاحظات القابضة"
        values[`evaluate_2`]  = 1
        values[`canAdd_2`]  = ['can_add_2']
        values[`about_2`]  = "خطابات وملاحظات الشركة القابضة"

        values[`folder_3`]  = "خطابات وملاحظات الجهاز"
        values[`evaluate_3`]  = 1
        values[`canAdd_3`]  = ['can_add_3']
        values[`about_3`]  = "خطابات وملاحظات الجهاز التنظيمي"

        values[`folder_4`]  = "خطابات وملاحظات الصحة/اللجنة العليا"
        values[`evaluate_4`]  = 1
        values[`canAdd_4`]  = ['can_add_4']
        values[`about_4`]  = "خطابات وملاحظات وزارة الصحة واللجنة العليا"

        values[`folder_5`]  = "المخاطبات"
        values[`evaluate_5`]  = 0
        values[`canAdd_5`]  = []
        values[`about_5`]  = "المخاطبات الداخلية الخاصة بالشركة التابعة والجهات الفعالة داخليا وخاريجا"

        values[`folder_6`]  = "المتطلبات الإدارية"
        values[`evaluate_6`]  = 0
        values[`canAdd_6`]  = []
        values[`about_6`]  = "القرارات الإدارية واللجان وفرق العمل"

        values[`folder_7`]  = "المقدمة"
        values[`evaluate_7`]  = 0
        values[`canAdd_7`]  = []
        values[`about_7`]  = "مقدمة الخطة"

        values[`folder_8`]  = "شبكة التجميع والروافع"
        values[`evaluate_8`]  = 0
        values[`canAdd_8`]  = []
        values[`about_8`]  = "كل ما يتعلق بشبكة التجميع والروافع من البداية حتي تحليل المخاطر"

        values[`folder_9`]  = "محطة المعالجة "
        values[`evaluate_9`]  = 0
        values[`canAdd_9`]  = []
        values[`about_9`]  = "كل ما يتعلق بمحطة المعالجة من البداية حتي تحليل المخاطر"

        values[`folder_10`]  = "صرف السيب النهائي وإعادة الاستخدام "
        values[`evaluate_10`]  = 0
        values[`canAdd_10`]  = []
        values[`about_10`]  = "كل ما يتعلق بصرف السيب النهائي وإعادة الاستخدام من البداية حتي تحليل المخاطر"

        values[`folder_11`]  = "الحمأة"
        values[`evaluate_11`]  = 0
        values[`canAdd_11`]  = []
        values[`about_11`]  = "كل ما يتعلق بالحمأة من البداية حتي تحليل المخاطر"

        values[`folder_12`]  = "المرفقات"
        values[`evaluate_12`]  = 0
        values[`canAdd_12`]  = []
        values[`about_12`]  = "جميع مرفقات الخطة"

        values[`folder_13`]  = "اللجنة العليا"
        values[`evaluate_13`]  = 0
        values[`canAdd_13`]  = []
        values[`about_13`]  = "نسخة من غلاف الخطة-غلاف الملخص التنفيذي-الملخص التنفيذي-شيتات المخاطر"
        setFolderValues(values)
    },[])



    const formik = useFormik({
        initialValues: {
            plan_name: '',
            treatment_id: '',
            user_id: '',
            version:'1',
            plan_start : '',
            reviewer : '',
        },
        validate,
        onSubmit: async values => {
            try {
                setLoading(true)
                let res = await axios.post('/sewagePlan/create',{
                        plan_name : values.plan_name,
                    treatment_id : values.treatment_id,
                        user_id : values.user_id,
                    version : values.version,
                    values : folderValus,
                    plan_start : values.plan_start ? values.plan_start.getFullYear() + "-" + ( parseInt(values.plan_start.getMonth())+1) + "-" + values.plan_start.getDate() : "",
                    reviewer : values.reviewer
                    },{
                        headers : {
                            Accept : "application/json",
                            Authorization : "Bearer " + token,
                        }}
                )
                if ( res.status === 200 ) {
                    nav('/controlPanel/sewagePlans')
                }
            }catch(err) {
                console.error(err)
            }
            finally {
                setLoading(false)
            }
        },
    });
    return (
        <>
            {loading && <Oval
                height={80}
                width={80}
                color="blue"
                wrapperStyle={{}}
                wrapperClass="spinner_container"
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="gray"
                strokeWidth={2}
                strokeWidthSecondary={2}

            />}
            <div className="main">
                <div className="d-flex flex-row  text-center">
                    <Link to="/controlPanel/sewagePlans" className="btn btn-sm btn-outline-dark mb-3">{"<<"}</Link>
                    <h3 className="fs-5 mb-3 px-3 mt-1"> اضافة خطة مامونية مياه</h3>
                </div>
                <div className="row bg-white border border-light-2 rounded shadow-sm mx-auto" style={{maxWidth:"500px"}}>
                    <h3 className="fs-6 m-3 text-center"> بيانات الخطة</h3>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row p-3">
                            <label htmlFor="plan_name" className="mb-2">كود الخطة</label>
                            <input
                                id="plan_name"
                                name="plan_name"
                                type="text"
                                className="form-control"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.plan_name}
                            />
                            {formik.touched.plan_name && formik.errors.plan_name ? <div className="text-danger">{formik.errors.plan_name}</div> : null}
                            <label htmlFor="version" className="mb-2">اصدار الخطة</label>
                            <input
                                id="version"
                                name="version"
                                type="text"
                                className="form-control"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.version}
                            />
                            {formik.touched.version && formik.errors.version ? <div className="text-danger">{formik.errors.version}</div> : null}
                            <label htmlFor="company" className="mb-2 mt-2">الشركة</label>
                                <select
                                    id="company"
                                    name="company"
                                    onChange={(e) =>setCompany(e.target.value)}
                                    className="form-select" aria-label="Default select example"
                                    value={company}>
                                    <CompaniesOptions token={token}></CompaniesOptions>
                                </select>


                            <label htmlFor="treatment_id" className="mb-2 mt-2">نظام معالجة الصرف</label>
                            <select
                                id="treatment_id"
                                name="treatment_id"
                                onChange={formik.handleChange}
                                className="form-select" aria-label="Default select example"
                            >
                                <GetOptions token={token} table={"sewage"} field={"system_name"} company={company}></GetOptions>

                            </select>
                            {formik.touched.treatment_id && formik.errors.treatment_id ? <div className="text-danger">{formik.errors.treatment_id}</div> : null}
                            <label htmlFor="user_id" className="mb-2 mt-2">مستخدم بداية الخطة</label>
                            <select
                                id="user_id"
                                name="user_id"
                                onChange={formik.handleChange}
                                className="form-select" aria-label="Default select example"
                            >
                                <GetOptions token={token} table={"user"} field={"name"} company={company}></GetOptions>

                            </select>
                            {formik.touched.user_id && formik.errors.user_id ? <div className="text-danger">{formik.errors.user_id}</div> : null}
                            <label htmlFor="reviewer" className="mb-2 mt-2">مراجع الخطة</label>
                            <select
                                id="reviewer"
                                name="reviewer"
                                onChange={formik.handleChange}
                                className="form-select" aria-label="Default select example"
                            >
                                <GetOptions token={token} table={"user"} field={"name"} kind={5}></GetOptions>

                            </select>
                            {formik.touched.reviewer && formik.errors.reviewer ? <div className="text-danger">{formik.errors.reviewer}</div> : null}

                            <label htmlFor="date_created" className="mx-2 fs-6"> تاريخ بدء الخطة</label>
                            <Calendar className="" dateFormat={"yy-mm-dd"} inputId={"plan_start"}  name={"plan_start"}
                                      value={formik.values.plan_start && new Date(formik.values.plan_start)} onChange={(e) => {
                                formik.setFieldValue('plan_start', e.target.value);
                            }} />


                            <Button variant="success" type="submit" className="mt-4">
                                اضافة
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}